import React from "react";
import PropTypes from "prop-types";
import Book from "./index";
import { connect } from "react-redux";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import { t } from "../../../core/translate";
import CoursewareIcon from "../../library/icons/courseware/overlay";

const StoreBook = ({ bookStore, ...props }) => {
  const primary = [];
  primary.push({
    onClick: () => {
      window.open(bookStore.storeUrl, "_blank");
    },
    label: t("explore.view-in-store", "View in Store")
  });

  const badges = [
    {
      label: "",
      text: t("explore.view-in-store", "View in Store"),
      isButton: false
    }
  ];

  return (
    <Book
      {...props}
      overlayIcon={<CoursewareIcon />}
      title={bookStore.title}
      coverURL={bookStore.storeUrl}
      isbn={bookStore.vbid}
      primary={primary}
      onClick={() => window.open(bookStore.storeUrl, "_blank")}
      badges={badges}
    />
  );
};

const mapStateToProps = (state, props) => ({
  bookStore: bridgeSelectors.getBookStore(state, props.isbn)
});

StoreBook.propTypes = {
  isbn: PropTypes.string.isRequired,
  context: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
};

export default connect(mapStateToProps)(StoreBook);
